/** Property sayfası için cardDetail.result → gösterim alanları */
import { toProxyUrl } from "./normalizeListingDetail";

const FIELD_LABELS_TR = {
  net_square: "m² (Net)",
  gross_square: "m² (Brüt)",
  floor_count: "Kat Sayısı",
  floor_number: "Bulunduğu Kat",
  square: "m²",
  room_count: "Oda Sayısı",
  heating_type: "Isıtma",
  bath_count: "Banyo",
  build_age: "Bina Yaşı",
  deed_status: "Tapu",
  suitability_for_credit: "Krediye Uygunluk",
  furniture_status: "Eşya Durumu",
  usability: "Kullanım Durumu",
  trade: "Takas",
  flat_for_construction: "Kat Karşılığı",
};

const tr = (prop) => {
  if (!prop?.value) return "";
  if (prop.value.label?.tr != null) return String(prop.value.label.tr);
  if (prop.value.items?.[0]?.name?.tr != null) {
    return String(prop.value.items[0].name.tr);
  }
  return "";
};

export const extractListingFields = (cardDetail) => {
  const result = cardDetail?.result;
  if (!result) return null;

  const props = result.properties || [];
  const byKey = {};
  props.forEach((p) => {
    if (p?.key) byKey[p.key] = tr(p);
  });

  const priceRaw = byKey.price || result.priceDetail?.price || result.price;
  const priceNum =
    typeof priceRaw === "number" ? priceRaw : parseFloat(String(priceRaw).replace(/\D/g, "")) || 0;

  const extras = [];
  const used = new Set([
    "title",
    "description",
    "price",
    "square",
    "net_square",
    "gross_square",
    "room_count",
    "floor_count",
    "heating_type",
    "bath_count",
    "furniture_status",
    "usability",
    "build_age",
    "deed_status",
    "suitability_for_credit",
    "trade",
    "flat_for_construction",
  ]);

  props.forEach((p) => {
    const key = p?.key;
    if (!key || used.has(key)) return;
    const val = tr(p);
    if (!val) return;
    const label =
      FIELD_LABELS_TR[key] ||
      p.name ||
      key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    extras.push({ label, value: val });
  });

  return {
    title: byKey.title || "",
    description: byKey.description || "",
    priceNum,
    locationLine: [result.location?.city, result.location?.district, result.location?.town]
      .filter(Boolean)
      .join(" / "),
    createdAt: result.createdAt,
    id: result.id,
    images: (result.images?.length
      ? result.images
      : result.imagesFullPath?.length
      ? result.imagesFullPath
      : result.thumbnailOriginal
      ? [result.thumbnailOriginal]
      : []
    )
      .map((img) => {
        const raw =
          typeof img === "object" && img !== null
            ? img.originalImageUrl || img.url || img.src || img.path || ""
            : String(img || "");
        return {
          ...((typeof img === "object" && img !== null) ? img : {}),
          originalImageUrl: toProxyUrl(raw),
        };
      })
      .filter((img) => Boolean(img.originalImageUrl)),
    listingUrl: result.url || "",
    category: result.metadata?.category?.name?.tr || "",
    tradeType: result.metadata?.tradeType?.name?.tr || "",
    estateType: result.metadata?.estateType?.name?.tr || "",
    roomCount: byKey.room_count || "",
    square: byKey.square || "",
    netSquare: byKey.net_square || "",
    grossSquare: byKey.gross_square || "",
    floorCount: byKey.floor_number || byKey.floor_count || "",
    heating: byKey.heating_type || "",
    bathCount: byKey.bath_count || "",
    furniture: byKey.furniture_status || "",
    usability: byKey.usability || "",
    buildAge: byKey.build_age || "",
    deed: byKey.deed_status || "",
    credit: byKey.suitability_for_credit || "",
    trade: byKey.trade || "",
    flatForConstruction: byKey.flat_for_construction || "",
    extras,
  };
};

export const formatPriceTL = (amount) => {
  const n = typeof amount === "number" ? amount : parseFloat(String(amount).replace(/\D/g, "")) || 0;
  return new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(n);
};
